import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.css']
})
export class QuestionComponent implements OnInit {

  @Input()
  id?: any;

  @Input()
  qId?: string;

  @Input()
  score = 0;

  @Input()
  text = '';

  @Input()
  isStudent = false;

  @Output() scoreChanged: EventEmitter<any> = new EventEmitter();



  constructor() { }

  ngOnInit(): void {
  }

  incrementScore(): void {
    this.score = (this.score + 1) % 4;
    this.scoreChanged.emit(this);
  }

  getColor(): string {
    switch (this.score) {
      case 1: return 'button-input--red';
      case 2: return 'button-input--orange';
      case 3: return 'button-input--green';
      default: return 'button-input--empty';
    }
  }
}
